import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  const navigate = useNavigate();

  return (
    <div className="breadcrumb-bar">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <React.Fragment key={index}>
            {index > 0 && <span className="breadcrumb-separator">›</span>}
            {isLast ? (
              <span className="breadcrumb-current">{item.label}</span>
            ) : !item.path ? (
              <span className="breadcrumb-text">{item.label}</span>
            ) : (
              <button
                className="breadcrumb-link"
                onClick={() => navigate(item.path!)}
              >
                {item.label}
              </button>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
